const boardingOptionsPostBookingUtils = require('../../../utils/postbooking/js/boarding_options');
const postBookingUtils = require('../../../utils/postbooking/js/utils');

const CONST = {
    templateName: 'boxEnhanced',
    outboundFlightIconClass: 'odf-icon-flight-right',
    inboundFlightIconClass: 'odf-icon-flight-left',
    parentIcon: 'odf-support-priority-boarding',
    parentIconSize: 'odf-icon-svg-s',
    titleClasses: 'odf-text-2xl',
    allowanceInfoClasses: 'odf-link',
    informativeStatusBoxClasses: 'odf-msg-informative odf-strong',
    informativeStatusIconClasses: 'odf-icon-information',
    productInfoTextClass: 'odf-text-md',

};

class UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        this.CONST = Odigeo._.merge({}, CONST, constants);
        this.view = view;
        this.templates = templates;
        this.keys = keys;
        this.bookingInfo = bookingInfo || {};
    }

    isProductAvailable() {
        return false;
    }

    getData() {
        return {
            template: {
                name: this.CONST.templateName,
            },
            isSelected: false,
            productAvailable: this.isProductAvailable(),
            parent: {
                base: {
                    icon: {
                        classes: [this.CONST.parentIcon, this.CONST.parentIconSize].join(' '),
                    },
                    title: {
                        text: this.keys.title,
                        classes: this.CONST.titleClasses,
                    },
                    productInfo: {
                        text: this.keys.allowanceInfo,
                        classes: this.CONST.allowanceInfoClasses,
                        onClick: this.view.onClickProductInfo.bind(this.view),
                    },
                    additionalInfo: {
                        text: this.templates.infoBox(this.getAdditionalInfoData()),
                    },
                },
            },
            child: {
                hide: true,
                custom: true,
            },
        };
    }

    getAdditionalInfoData() {
        return {
            keys: this.keys,
            productInfoTextClass: this.CONST.productInfoTextClass,
            isRoundTrip: postBookingUtils.isRoundTrip(this.bookingInfo),
            inboundFlightIconClass: this.CONST.inboundFlightIconClass,
            outboundFlightIconClass: this.CONST.outboundFlightIconClass,
            boardingOptionsPerLeg: boardingOptionsPostBookingUtils.getBoardingOptionsInfoFromBookingInfo(this.bookingInfo),
        };
    }
}

module.exports = UIStrategy;
